import {Component, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild} from '@angular/core';
import {GeneralService, SnackbarService} from '../../../../../../core/services';
import {Router} from '@angular/router';
import {Table} from 'primeng/table';
import {TableColumnDef} from '../../../../../../shared/tables/table-column-def';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'pr-product-logics-modal-summary-new',
  templateUrl: './product-logics-modal-summary-new.component.html',
  styleUrls: ['./product-logics-modal-summary-new.component.scss', '../../../../../../components/new-table/base-table.scss']
})
export class ProductLogicsModalSummaryNewComponent implements OnInit {

    @HostBinding('class') classes = 'flex flex-grow';

    @ViewChild('dt', {static: false}) dt: Table;

    @Input() columnsData: Array<TableColumnDef>;
    @Input() tableData: any[];
    @Input() title: string;
    @Input() tableId: string;

    @Input()
    set customPageSize(value: number) {
        if (value === this.perPage) {
            return;
        }
        this.perPage = value;
    }

    @Output() removeProduct = new EventEmitter();

    @Output() customPageSizeChange = new EventEmitter();

    perPage = 25;

    idFieldName: string;
    filterGlobalControl = new FormControl('');
    columns: TableColumnDef[];

    selected = [];

    showTable = true;

    private selectedField: TableColumnDef = {
        field: 'selectedField',
        columnDef: 'selectedField',
        header: 'Selected',
        showSort: false,
        showSearch: false,
        width: 10
    };

    private removeField: TableColumnDef = {
        field: 'removeField',
        columnDef: 'removeField',
        header: '',
        showSort: false,
        showSearch: false,
        width: 10
    };

    constructor(
        private router: Router,
        public generalService: GeneralService,
        private snackBar: SnackbarService,
    ) {

    }

    ngOnInit(): void {
        const tmpColumns = [].concat(this.columnsData);
        this.idFieldName = tmpColumns.shift().columnDef;

        this.columns = [this.selectedField, ...tmpColumns, this.removeField];

        this.tableId = 'Table_' + this.tableId;
    }

    onPage(event) {
        this.customPageSizeChange.emit(event.rows);
    }

    clearGlobalFilter() {
        this.dt.filterGlobal('', 'contains');
        this.filterGlobalControl.reset();
    }

    getTooltip(column: Object, row: any): string {
        try {
            switch (column['type']) {
                case 'date':
                    return row ? this.generalService.parseDate(row) : row;
                    break;
                case 'vat':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(0)
                        : row;
                    break;
                case 'margin':
                    return row
                        ? this.generalService.parseVAT(row).toFixed(1)
                        : row;
                default:
                    break;
            }
            switch (column['suffix']) {
                case 'currency':
                    return row ? row.toFixed(2) : row;
                    break;
                default:
                    return row;
                    break;
            }
        } catch (e) {
            console.log(e);
            console.log('error in type');
        }
    }

    searchByColumn(col: TableColumnDef) {
        this.dt.filter(
            col.searchValue,
            col.field,
            'contains'
        );

        col.searched = true;
    }

    clearSearchByColumn(col: TableColumnDef) {
        col.searchValue = '';
        this.dt.filter(
            col.searchValue,
            col.field,
            'contains'
        );

        col.searched = false;
    }

    removeRow(row) {
        this.selected = this.selected.filter((sel) => sel.Id !== row.Id);
        this.removeProduct.emit(row[this.idFieldName]);
    }

    removeSelectedItems() {
        this.selected.forEach(elem => this.removeRow(elem));
    }

    removeAllItems() {
        this.dt.value.forEach(elem => this.removeRow(elem));
    }

    resetTable() {
        this.dt.clear();
        this.dt.clearState();
        this.showTable = false;

        setTimeout(() => {
            this.showTable = true;
        }, 0);
    }

    public checkInputConfIncorrect(row: any) {
        return row < 0 || !row || row > 10000;
    }

    public checkInputMinIncorrect(lowVal: any, highVal: any) {
        return !lowVal || lowVal > 300 || lowVal > highVal;
    }

    public checkInputMaxIncorrect(lowVal: any, highVal: any) {
        return !highVal || highVal > 300 || lowVal > highVal;
    }

}
